import script from "./Content.vue?vue&type=script&setup=true&lang=js"
export * from "./Content.vue?vue&type=script&setup=true&lang=js"

import "./Content.vue?vue&type=style&index=0&id=06f40db2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06f40db2"]])

export default __exports__